module.exports = __webpack_public_path__ + "c932cad2f304bed1b90014524efeddc1.jpg";